import React from 'react';
import { Row, Col } from 'react-bootstrap';
import size from 'lodash.size';
import head from 'lodash.head';
// import filter from 'lodash.filter';
import find from 'lodash.find';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import Markets from './Markets';
import MainMarket from './Markets/MainMarket';
import * as Maps from '../../store/map';
import Util from '../../helper/Util';

function Matche(props) {
    const openResult = (value) => {
        let { activeMatchId } = props.lSports.inplay;
        let activeId = value === activeMatchId ? '' : value;
        props.lsportsActions.inplay.setActiveMatchId(activeId);
    };

    const ShowStats = () => {};

    let { event } = props;
    let { activeMatchId, mainMarket } = props.lSports.inplay;
    let currentMainMarket = find(mainMarket, (m) => m.Id === event.Fixture.Sport.Id);
    let isLive = event.Fixture.Status === 2 || event.Fixture.Status;
    let isLiveSteram = false;
    let results = event.Livescore && event.Livescore.Scoreboard && event.Livescore.Scoreboard.Results ? event.Livescore.Scoreboard.Results : null;
    let drawResult = results ? results[0].Value + ' : ' + results[1].Value : null;

    let score = isLive ? (
        <Col xs="2" lg="2" className="p-1 pt-2 mt-2 text-center active fs-15" onClick={(e) => openResult(event.FixtureId)}>
            {drawResult}
        </Col>
    ) : (
        <Col className="p-2  text-center active ">
            <time>{format(event.Fixture.StartDate, 'dd/MM/yy')}</time>
            <br />
            <time>{format(event.Fixture.StartDate, 'kk:mm')}</time>
        </Col>
    );

    let statistics = (
        <Col xs="1" lg="1" className="p-1 pt-2 mt-2 text-center" onClick={ShowStats}>
            <i className="icon-stats"></i>
        </Col>
    );

    let livestream =
        isLive && isLiveSteram ? (
            <Col xs="1" lg="1" className="p-1 pt-0 mt-2 text-center">
                <i className="fs-18 icon-livestream" style={{ color: 'red' }}></i>
            </Col>
        ) : (
            <Col xs="1" lg="1" className="p-1 pt-0 mt-2 text-center"></Col>
        );

    let participants = (
        <Col xs="6" lg="6" md="auto" className=" p-2  text-overflow font-weight-bold" onClick={(e) => openResult(event.FixtureId)}>
            {event.Fixture.Participants[0].Name} <br /> {event.Fixture.Participants[1].Name}
        </Col>
    );

    let sortedMarkets = Util.sortMarket(event.Markets, event.Fixture.Sport.Id);
    let mainMarketEvent = find(sortedMarkets, (m) => m.Id === currentMainMarket.selectedMarket);

    if (!mainMarketEvent) {
        mainMarketEvent = head(sortedMarkets);
    }

    //sortedMarkets = filter(sortedMarkets, m => m.Id !== mainMarketEvent.Id);

    let drawMarkets = activeMatchId === event.FixtureId ? <Markets markets={sortedMarkets} fixture={event} /> : null;

    let colLength = isLive ? 2 : 3;
    let matchesInfo = (
        <Col xs={colLength} lg={colLength} className=" p-1 pt-2 text-right mt-2 fs-15" onClick={(e) => openResult(event.FixtureId)}>
            <span className=" pr-4">+{size(sortedMarkets)}</span>
            <i className={`live-dropdown-arror fs-14 ${activeMatchId === event.FixtureId ? 'icon-angle-down' : 'icon-angle-right'}`}></i>
        </Col>
    );

    if (mainMarketEvent === undefined) return null;

    return (
        <div>
            <div className="match-panel">
                <div>
                    <Row className="mx-auto match-inner-panel">
                        <div className="width-95 mx-auto">
                            {participants}
                            {score}
                            {statistics}
                            {livestream}
                            {matchesInfo}
                        </div>
                    </Row>
                    <MainMarket market={mainMarketEvent} fixture={event} isLive={isLive} />
                </div>
                <div className={`result-open-panel ${activeMatchId === event.FixtureId ? 'open-result' : ''}`}>{drawMarkets}</div>
            </div>
        </div>
    );
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(Matche);
